/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const GLOBAL_ACTIVITY_ID = 'workbench.actions.manage';
export const ACCOUNTS_ACTIVITY_ID = 'workbench.actions.accounts';
